import { Client } from '@app/core/types/client';
import { User } from '@mi-front/core';
import { useImpersonation } from '../hooks/useImpersonationStore';
import { buildTabAuthAsAppUrl } from './build-tab-auth-as-url';

/**
 * Opens a new browser tab impersonating the given user (session-only `auth_as`).
 * Also records the user in recent impersonations without changing the persisted selection.
 */
export function useOpenTabAuthAs() {
  const { addRecentUser } = useImpersonation();

  function openTabAuthAs(user: User & { client: Client }) {
    addRecentUser(user);
    window.open(buildTabAuthAsAppUrl(user.id), '_blank', 'noopener,noreferrer');
  }

  return { openTabAuthAs };
}
